var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _circle4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5203,
    cy: 14.6971,
    r: 6.95136,
    stroke: "#ffb4be",
    strokeWidth: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.53022,
    cx: 26.5204,
    cy: 14.6947,
    r: 9.80406,
    stroke: "#ffb4be"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.382791,
    cx: 26.5205,
    cy: 14.6963,
    r: 11.8311,
    stroke: "#ffb4be"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6621 15.034L-6.86646e-05 15.034L24.6621 15.034Z",
    fill: "#ffb4be"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6621 15.034L-6.85453e-05 15.034",
    stroke: "#ffb4be",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 14.8647L27.7027 14.8647L50 14.8647Z",
    fill: "#ffb4be"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14.8647L27.7027 14.8647",
    stroke: "#ffb4be",
    strokeWidth: 1.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.382791,
    cx: 26.5202,
    cy: 14.696,
    r: 14.196,
    stroke: "#ffb4be"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5205 13.3447L29.2232 16.0474L26.5205 13.3447Z",
    fill: "#ffb4be"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5205 13.3447L29.2232 16.0474",
    stroke: "#ffb4be",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5708 13.3447L25.2735 16.0474L22.5708 13.3447Z",
    fill: "#ffb4be"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5708 13.3447L25.2735 16.0474",
    stroke: "#ffb4be",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockage);
export default __webpack_public_path__ + "static/media/blockage.4d0e36bc2a42f3728ffa4d11132132db.svg";
export { ForwardRef as ReactComponent };